import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import AppLayout from "../components/AppLayout";
import ModuleOverviewPage from "../components/ModuleOverviewPage";
import { NAV_GROUPS, findGroupForKey } from "../navigation/navTree";

import ReportPage from "./ReportPage";
import UrugoUmuryango from "../components/UrugoUmuryango";
import Urubyiruko from "../components/Urubyiruko";
import Abana from "../components/Abana";
import AbashesheAkanguhe from "../components/AbashesheAkanguhe";
import IngoZifiteAmacyimbirane from "../components/IngoZifiteAmacyimbirane";
import IbikorwaRaporo from "./IbikorwaRaporo";
import ImiberehoMyiza from "./ImiberehoMyiza";
import Ingo from "./Ingo";
import Ubwishingizi from "./Ubwishingizi";
import Isibo from "./Isibo";
import Ubukungu from "./Ubukungu";
import Uburezi from "./Uburezi";
import Ubuzima from "./Ubuzima";
import Abaturage from "./Abaturage";
import Message from "./Message";
import AbaturageBafiteInkunguzaleta from "./AbaturageBafiteInkunguzaleta";
import UmusanzuEjoheza from "./UmusanzuEjoheza";
import RegisterM from "../components/AddumuyobozMudugudu";
import GuhinduraUmuyobozi from "../components/GuhinduraUmuyobozi";
import KurwanyaUmwanda from "./KurwanyaUmwanda";
import IsukuIsukura from "./IsukuIsukura";
import Messaging from "../components/Messaging";
import Broadcasts from "../components/Broadcasts";
import RaporoZoherejwe from "../components/RaporoZoherejwe";
import AmatangazoMudugudu from "../components/AmatangazoMudugudu";
import OherezaIkibazo from "../components/OherezaIkibazo";
import IbibazoByanye from "../components/IbibazoByanye";
import { VillageNavButton } from "../components/VillageInfoSystem";
import AbashyitsiMudugudu from "../components/AbashyitsiMudugudu";
import MudugudAttendanceViewer from "../components/MudugudAttendanceViewer";
import UmutekanoMudugudu from "../components/UmutekanoMudugudu";
import IbikorwaRemezoMudugudu from "../components/IbikorwaRemezoMudugudu";
import IbiregoMudugudu from "../components/IbiregoMudugudu";
import ImicoImyifatire from "../components/ImicoImyifatire";
import AbanaMuMihanda from "../components/AbanaMuMihanda";

/* ── VillageInfo Wrapper ── */
const VillageInfoWrapper = ({ currentUser }) => (
  <div style={{ display: "flex", justifyContent: "center", padding: "2rem 0" }}>
    <VillageNavButton role="mudugudu" currentUser={currentUser} />
  </div>
);

/* ── Quick Actions: grouped the same way as the sidebar (NAV_GROUPS), so the
   two never drift apart. Each top-level group gets one color. Keys must
   match NAV_GROUPS[].key in navigation/navTree.js. ── */
const GROUP_COLORS = {
  "rusange":          { color: "#7c3aed", bg: "#ede9fe" },
  "abaturage-ingo":   { color: "#0f766e", bg: "#ccfbf1" },
  "imibereho":        { color: "#be123c", bg: "#ffe4e6" },
  "ubuzima-uburezi":  { color: "#0369a1", bg: "#e0f2fe" },
  "ubukungu":         { color: "#b45309", bg: "#fef3c7" },
  "isuku-remezo":     { color: "#0891b2", bg: "#cffafe" },
  "umutekano":        { color: "#7c3aed", bg: "#ede9fe" },
  "ibikorwa-isibo":   { color: "#0d9488", bg: "#ccfbf1" },
  "raporo":           { color: "#1d4ed8", bg: "#dbeafe" },
  "itumanaho":        { color: "#15803d", bg: "#dcfce7" },
  "ubuyobozi":        { color: "#475569", bg: "#e2e8f0" },
};

const FALLBACK_COLOR = { color: "#475569", bg: "#e2e8f0" };

// Quick Actions mirrors the sidebar, minus "Rusange" (a shortcut to the
// page you're already on).
const QUICK_ACTION_GROUPS = NAV_GROUPS.filter((g) => g.key !== "rusange");

const flattenLeaves = (node) => (node.children ? node.children.flatMap(flattenLeaves) : [node]);

/* ── Government card style ── */
const glassCard = {
  background: "#ffffff",
  border: "1px solid #d1d9e6",
  borderRadius: "8px",
  boxShadow: "0 1px 4px rgba(0,51,102,0.08)",
};

/* ── One collapsible row on the Quick Actions panel: shows just the group
   (icon + label + item count) until tapped, then reveals its tiles. ── */
const QuickActionGroup = ({ icon, label, palette, leaves, isOpen, onToggle, onNavigate, isLast }) => (
  <div style={{ borderBottom: isLast ? "none" : "1px solid #eef2f7" }}>
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={isOpen}
      className="w-full flex items-center gap-2.5 px-2 py-2.5 transition-colors duration-150"
      style={{ background: "transparent", border: "none", cursor: "pointer", textAlign: "left" }}
      onMouseEnter={e => { e.currentTarget.style.background = "#f8fafc"; }}
      onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
    >
      <div className="w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0" style={{ background: palette.bg, color: palette.color }}>
        <i className={`bi ${icon}`} />
      </div>
      <span className="flex-1 text-sm font-bold" style={{ color: "#1e3a5f" }}>{label}</span>
      <span className="text-[10px] font-semibold" style={{ color: "#94a3b8" }}>{leaves.length}</span>
      <i className={`bi bi-chevron-${isOpen ? "up" : "down"} text-xs`} style={{ color: "#94a3b8" }} />
    </button>
    {isOpen && (
      <div className="grid gap-2 pb-3 px-2" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(76px, 1fr))" }}>
        {leaves.map((leaf) => (
          <button
            key={leaf.key}
            onClick={() => onNavigate?.(leaf.key)}
            title={leaf.label}
            className="flex flex-col items-center gap-1.5 p-2.5 transition-all duration-150 active:scale-95"
            style={{ background: "#f8fafc", border: "1px solid #d1d9e6", borderRadius: "6px" }}
            onMouseEnter={e => { e.currentTarget.style.background = "#e8f0fe"; e.currentTarget.style.borderColor = "#003366"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#d1d9e6"; }}
          >
            <div className="w-9 h-9 rounded-lg flex items-center justify-center text-base flex-shrink-0" style={{ background: palette.bg, color: palette.color }}>
              <i className={`bi ${leaf.icon}`} />
            </div>
            <span className="text-[10px] font-semibold leading-tight text-center line-clamp-2" style={{ color: "#1e3a5f" }}>
              {leaf.label}
            </span>
          </button>
        ))}
      </div>
    )}
  </div>
);

/* ── Dashboard Overview ── */
const DashboardOverview = ({ user, onNavigate }) => {
  const [openGroup, setOpenGroup] = useState(null);
  const recentActivities = [
    { action: "Umuturage mushya yashyizwemo", time: "Saa 2 ishize", icon: "bi-person-plus",  color: "#10b981", bg: "rgba(16,185,129,0.12)" },
    { action: "Isibo nshya yashyizwemo",      time: "Saa 5 ishize", icon: "bi-geo-alt",      color: "#3b82f6", bg: "rgba(59,130,246,0.12)" },
    { action: "Urugo rushya rwanditswe",       time: "Ejo",          icon: "bi-house-add",    color: "#8b5cf6", bg: "rgba(139,92,246,0.12)" },
  ];

  return (
    <div className="space-y-4">
      {/* Greeting banner */}
      <div
        className="relative overflow-hidden p-5"
        style={{
          background: "linear-gradient(135deg, #003366 0%, #004080 100%)",
          borderRadius: "8px",
          borderLeft: "5px solid #FFD700",
          boxShadow: "0 2px 8px rgba(0,51,102,0.2)",
        }}
      >
        <div className="flex items-center gap-4">
          <div
            className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ background: "rgba(255,215,0,0.15)", border: "1px solid rgba(255,215,0,0.3)" }}
          >
            <i className="bi bi-person-circle text-2xl" style={{ color: "#FFD700" }} />
          </div>
          <div className="min-w-0">
            <h2 className="font-bold text-white leading-tight" style={{ fontSize: "clamp(1rem, 2.5vw, 1.2rem)" }}>
              Murakaza neza, {user?.name || "Umukoresha"}!
            </h2>
            <p className="text-xs mt-1" style={{ color: "rgba(255,255,255,0.7)" }}>
              <i className="bi bi-calendar-event mr-1" />
              {new Date().toLocaleDateString("rw-RW", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
            </p>
          </div>
          {/* Rwanda coat of arms accent */}
          <div className="ml-auto hidden sm:flex items-center gap-1 flex-shrink-0">
            <i className="bi bi-shield-fill text-3xl" style={{ color: "rgba(255,215,0,0.25)" }} />
          </div>
        </div>
      </div>

      {/* Quick Actions + Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Quick Actions */}
        <div className="lg:col-span-2" style={glassCard}>
          <div
            className="px-5 py-3 flex items-center gap-2"
            style={{ borderBottom: "2px solid #003366", background: "#003366", borderRadius: "8px 8px 0 0" }}
          >
            <i className="bi bi-lightning-charge-fill" style={{ color: "#FFD700" }} />
            <h3 className="text-sm font-bold text-white">Ibikorwa Byihuse</h3>
          </div>
          <div className="p-2">
            {QUICK_ACTION_GROUPS.map((group, idx) => (
              <QuickActionGroup
                key={group.key}
                icon={group.icon}
                label={group.label}
                palette={GROUP_COLORS[group.key] || FALLBACK_COLOR}
                leaves={flattenLeaves(group)}
                isOpen={openGroup === group.key}
                onToggle={() => setOpenGroup((k) => (k === group.key ? null : group.key))}
                onNavigate={onNavigate}
                isLast={idx === QUICK_ACTION_GROUPS.length - 1}
              />
            ))}
          </div>
        </div>

        {/* Recent Activity */}
        <div style={glassCard}>
          <div
            className="px-5 py-3 flex items-center gap-2"
            style={{ borderBottom: "2px solid #20603D", background: "#20603D", borderRadius: "8px 8px 0 0" }}
          >
            <i className="bi bi-clock-history text-white" />
            <h3 className="text-sm font-bold text-white">Ibikorwa Biheruka</h3>
          </div>
          <div className="p-4 space-y-3">
            {recentActivities.map((activity, i) => (
              <div
                key={i}
                className="flex items-start gap-3 pb-3 last:pb-0"
                style={{ borderBottom: i < recentActivities.length - 1 ? "1px solid #e8edf3" : "none" }}
              >
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: activity.bg }}
                >
                  <i className={`bi ${activity.icon} text-sm`} style={{ color: activity.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-semibold leading-snug" style={{ color: "#1e3a5f" }}>{activity.action}</p>
                  <p className="text-[10px] mt-0.5" style={{ color: "#64748b" }}>
                    <i className="bi bi-clock mr-1" />{activity.time}
                  </p>
                </div>
              </div>
            ))}
            <button
              className="w-full flex items-center justify-center gap-1.5 py-2 rounded text-xs font-bold transition-all duration-150"
              style={{ background: "#003366", color: "#FFD700", border: "none" }}
              onMouseEnter={e => e.currentTarget.style.background = "#004080"}
              onMouseLeave={e => e.currentTarget.style.background = "#003366"}
              onClick={() => onNavigate?.("raporo")}
            >
              Reba Raporo yose <i className="bi bi-arrow-right ml-1" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const BOTTOM_NAV = [
  { key: "overview",          icon: "bi-house-fill",                    label: "Ahabanza" },
  { key: "abaturage",         icon: "bi-people-fill",                   label: "Abaturage" },
  { key: "messaging",         icon: "bi-envelope-fill",                 label: "Chat" },
  { key: "raporoZoherejwe",   icon: "bi-file-earmark-arrow-down-fill",  label: "Raporo" },
  { key: "amatangazoAkagari", icon: "bi-megaphone-fill",                label: "Tangazo" },
];

/* ── MAIN DASHBOARD ── */
const Dashboard = ({ user }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "overview";
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (!token) { navigate("/", { replace: true }); return; }
    if (role && role !== "Mudugudu") { navigate("/mudugudu", { replace: true }); }
  }, [navigate]);

  const handleTabChange = useCallback((key) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("tab", key);
      return next;
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [setSearchParams]);

  // Level 2 of the nav: clicking a multi-item sidebar group lands here, on
  // that group's own key, and we show its children as ModuleOverviewPage
  // cards. Single-item groups (e.g. Rusange) skip straight to their page.
  const overviewGroup = NAV_GROUPS.find(
    (g) => g.key === activeTab && (g.children?.length || 0) > 1
  );

  // isUmudugudu=true tells page components to fetch via /umudugudu/module-data/:module
  // which JOINs abandi.sup_id = mudugudu.user_id — only shows linked Isibo data
  const renderContent = () => {
    if (overviewGroup) {
      return (
        <ModuleOverviewPage
          icon={overviewGroup.icon}
          color={overviewGroup.color}
          label={overviewGroup.label}
          description={overviewGroup.description}
          items={overviewGroup.children.map((c) => ({ ...c, color: c.color || overviewGroup.color }))}
          onNavigate={handleTabChange}
        />
      );
    }
    switch (activeTab) {
      case "overview":           return <DashboardOverview user={user} onNavigate={handleTabChange} />;
      case "abaturage":          return <Abaturage isUmudugudu />;
      case "ingo":               return <Ingo isUmudugudu />;
      case "ubwishingizi":       return <Ubwishingizi isUmudugudu />;
      case "uburezi":            return <Uburezi isUmudugudu />;
      case "isibo":              return <Isibo isUmudugudu />;
      case "imibereho":          return <ImiberehoMyiza isUmudugudu />;
      case "ubukungu":           return <Ubukungu isUmudugudu />;
      case "ubuzima":            return <Ubuzima isUmudugudu />;
      case "urugo-umuryango":    return <UrugoUmuryango isUmudugudu />;
      case "urubyiruko":         return <Urubyiruko isUmudugudu />;
      case "abana":              return <Abana isUmudugudu />;
      case "abasheshe":          return <AbashesheAkanguhe isUmudugudu />;
      case "amacyimbirane":      return <IngoZifiteAmacyimbirane isUmudugudu />;
      case "inkunga":            return <AbaturageBafiteInkunguzaleta isUmudugudu />;
      case "kurwanyaUmwanda":    return <KurwanyaUmwanda isUmudugudu />;
      case "isukuIsukura":       return <IsukuIsukura isUmudugudu />;
      case "umusanzuEjoheza":    return <UmusanzuEjoheza isUmudugudu />;
      case "isibo-attendance":    return <MudugudAttendanceViewer />;
      case "message":            return <Message />;
      case "messaging":          return <Messaging />;
      case "amatangazo":         return <Broadcasts />;
      case "amatangazoAkagari":  return <AmatangazoMudugudu />;
      case "Umuyobozi":          return <RegisterM />;
      case "guhinduraUmuyobozi": return <GuhinduraUmuyobozi />;
      case "raporo":             return <IbikorwaRaporo />;
      case "kwandikaRaporo":     return <ReportPage />;
      case "raporoZoherejwe":    return <RaporoZoherejwe />;
      case "oherezaIkibazo":     return <OherezaIkibazo onSuccess={() => handleTabChange("ibibazoByanye")} />;
      case "ibibazoByanye":      return <IbibazoByanye />;
      case "abashyitsi-dufite":  return <AbashyitsiMudugudu />;
      case "umutekano-leader":   return <UmutekanoMudugudu />;
      case "ibikorwa-remezo":    return <IbikorwaRemezoMudugudu />;
      case "isibo-ibirego":      return <IbiregoMudugudu />;
      case "imico-imyifatire":   return <ImicoImyifatire mode="village" />;
      case "abana-binzererezi":  return <AbanaMuMihanda mode="village" />;
      case "villageInfo":         return <VillageInfoWrapper currentUser={user?.name} />;
      default:                   return <DashboardOverview user={user} onNavigate={handleTabChange} />;
    }
  };

  return (
    <AppLayout
      title=""
      groups={NAV_GROUPS}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      bottomNavItems={BOTTOM_NAV}
    >
      {/* Back button — mobile only, non-overview tabs. From a leaf page it
          returns to that leaf's group overview; otherwise to the dashboard. */}
      {activeTab !== "overview" && (() => {
        const parent = overviewGroup ? null : findGroupForKey(NAV_GROUPS, activeTab);
        const backTo = parent && parent.children.length > 1 ? parent.key : "overview";
        const backLabel = backTo === "overview" ? "Subira ku Dashboard" : `Subira: ${parent.label}`;
        return (
          <div className="lg:hidden mb-4">
            <button
              onClick={() => handleTabChange(backTo)}
              className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold
                         text-slate-300 transition-all duration-200 active:scale-95"
              style={{
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              <i className="bi bi-arrow-left" />
              {backLabel}
            </button>
          </div>
        );
      })()}
      {renderContent()}
    </AppLayout>
  );
};

export default Dashboard;
